<template>
  <div style="width: 100%; height: 100%">
    <div ref="mapRoot" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import OSM from 'ol/source/OSM'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import {fromLonLat} from 'ol/proj'
import Style from 'ol/style/Style'
import CircleStyle from 'ol/style/Circle'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'

export default {
  name: 'MapContainerDemo',
  props: ['transportOrderNbr'],
  data() {
    return {
      map: null,
      vectorLayer: null,
    }

  },
  methods: {
    addMarker(lon, lat, name = 'New Marker') {
      if (!this.map || !this.vectorLayer) return;

      const feature = new Feature({
        geometry: new Point(fromLonLat([lon, lat])),
        name: name
      });

      // Style the new marker
      feature.setStyle(
          new Style({
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({ color: 'rgba(220, 53, 69, 0.7)' }), // red-ish
              stroke: new Stroke({ color: 'white', width: 2 })
            })
          })
      );

      this.vectorLayer.getSource().addFeature(feature);

      // Optional: center the map on the new marker
      this.map.getView().setCenter(fromLonLat([lon, lat]));
      this.map.getView().setZoom(14);
    }
  },
  mounted() {
    let features = []

    let center = fromLonLat([9.0, 44.3]) // center closer to Genoa-La Spezia path
    let zoom = 10 // closer zoom for detail

    if (this.transportOrderNbr === '7003591008') {
      // Current points: Milan, Turin, Bologna, Brescia
      features = [
        new Feature({
          geometry: new Point(fromLonLat([9.19, 45.4642])), // Milan
          name: 'Start: Milan'
        }),
        new Feature({
          geometry: new Point(fromLonLat([7.6869, 45.0703])), // Turin
          name: 'Activity 1: Turin'
        }),
        new Feature({
          geometry: new Point(fromLonLat([11.3426, 44.4949])), // Bologna
          name: 'Activity 2: Bologna'
        }),
        new Feature({
          geometry: new Point(fromLonLat([10.0012, 45.4212])), // End Location
          name: 'End: Near Brescia'
        })
      ]
      center = fromLonLat([9.5552, 45.1127])
      zoom = 6

    } else if (this.transportOrderNbr === '7003592144') {
      const roadTripPoints = [
        [8.9463, 44.4056],   // Genoa
        [8.9325, 44.4142],   // Castelletto area (north of city center)
        [8.9251, 44.4255],   // Righi area (hilly inland road)
        [8.9059, 44.4371],   // Sant'Eusebio (inland hills)
        [8.8785, 44.4458],   // Struppa
        [8.8572, 44.4540],   // Molassana
        [8.8355, 44.4650],   // Prato (Genoa inland suburb)
        [8.8108, 44.4755],   // San Martino di Struppa
        [8.7915, 44.4865],   // Bargagli (along SS45 road inland)
        [8.7701, 44.4968],   // Cisiano
        [8.7472, 44.5070],   // Laccio
        [8.7285, 44.5143],   // Torriglia
      ]
      features = roadTripPoints.map((coords, index) => {
        return new Feature({
          geometry: new Point(fromLonLat(coords)),
          name: `Tracking point ${index + 1}`
        })
      })

      center = fromLonLat([8.8553, 44.4624])
      zoom = 12
    } else if (this.transportOrderNbr === '7013037526') {
      const roadTripPoints = [
        [8.9462, 44.4056],  // Genoa (Port of Genoa - origin)
        [8.8693, 44.4782],  // Bolzaneto (Genoa truck-friendly exit via A7)
        [9.0152, 44.6457],  // Isola del Cantone (along A7)
        [8.8763, 44.8848],  // Tortona (A7/A21 junction - major logistics hub)
        [9.0097, 45.0095],  // Voghera (industrial zone, good truck rest point)
        [9.1583, 45.1705],  // Pavia (tangenziale/SS35 route to Milan)
        [9.1032, 45.4008],  // Assago (Milan South toll gate, highway approach)
        [9.2067, 45.5237]   // Milan (destination)
      ]
      features = roadTripPoints.map((coords, index) => {
        return new Feature({
          geometry: new Point(fromLonLat(coords)),
          name: `Tracking point ${index + 1}`
        })
      })

      center = fromLonLat([9.0144, 44.6021]);
      zoom = 8
    }


    // Simple style for points
    const pointStyle = new Style({
      image: new CircleStyle({
        radius: 7,
        fill: new Fill({color: 'rgba(0, 123, 255, 0.7)'}),
        stroke: new Stroke({color: 'white', width: 2})
      })
    })

    // Apply style to all features
    features.forEach(f => {
      f.setStyle(pointStyle)
      f.setId(f.get('name'))
    })

    // Create vector source and layer
    const vectorSource = new VectorSource({
      features: features
    })

    this.vectorLayer = new VectorLayer({
      source: vectorSource
    })

    // Initialize the map
    this.map = new Map({
      target: this.$refs.mapRoot,
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        this.vectorLayer
      ],
      view: new View({
        center: center,
        zoom: zoom
      })
    })
  },


}
</script>

<style scoped>
/* Make sure container takes full size */
div[ref="mapRoot"] {
  width: 100%;
  height: 100%;
}

</style>
